import { DraftIdentity } from "./DraftIdentity";

export enum ActionType {
    OpenEmpty,
    UploadFuf,
}

interface OpenEmptyAction {
    type: ActionType.OpenEmpty;
    gfv: string;
    dateString: string;
    editorUrl: string;
}

interface UploadFufAction {
    type: ActionType.UploadFuf;
    gfv: string;
    dateString: string;
    fufDriveUri: string;
    draft: DraftIdentity;
    editorUrl: string;
}

export type Action = OpenEmptyAction | UploadFufAction;
